module.exports = __webpack_public_path__ + "8bd8c3d9991dcd488aea63149e5ba3a4.pdf";